import { FC, ReactNode, useEffect, useState } from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import Filters from '@components/Items/Filters'
import { BsFilter } from 'react-icons/bs'
import Clear from '@components/Items/Filters/Active/Clear'
import useFilter from '@components/Items/utils/hooks/useFilter'
import getPagination from '@utilities/functions/getPagination'
import Pagination from '@components/PaginationLayout/Pagination'
import _isArray from 'lodash/isArray'

type PropTypes = {
  totalCount: number
  children: ReactNode
}

const Mobile: FC<PropTypes> = ({ totalCount, children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { itemSearchQuery, pageIdQuery, updateQuery } = useFilter()
  const pageChange = (pageId: number) => {
    if (pageId === Number(pageIdQuery) || (!pageIdQuery && pageId === 1)) return
    updateQuery('pageId', pageId)
  }
  const { current_page, total_pages } = getPagination(
    totalCount,
    Number(pageIdQuery) || 1
  )

  const handleOutsideClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (!target.closest('.sidebar-content')) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleOutsideClick)
    } else {
      document.removeEventListener('click', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [isOpen])

  return (
    <>
      <button
        className={`fixed top-5 right-5 z-50 p-2 bg-gray-800 text-white rounded-md focus:outline-none ${
          isOpen ? '' : 'hidden'
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <AiOutlineClose className="w-6 h-6" />
      </button>
      {isOpen && (
        <div className={`fixed inset-0 bg-gray-500 bg-opacity-75 z-40`} />
      )}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-white transition duration-300 transform h-screen overflow-auto ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="px-4 py-6 sidebar-content">
          <h2 className="font-semibold text-xl mb-4">Filters</h2>
          <Filters />
          <div className="text-center my-2">
            <Clear />
          </div>
        </div>
      </div>

      <div className="flex flex-col py-2 gap-2">
        <h1 className="font-bold text-2xl">
          {_isArray(itemSearchQuery)
            ? itemSearchQuery.map((query) => query.toUpperCase()).join(', ')
            : (itemSearchQuery || '').toUpperCase()}
        </h1>
        <div className="flex justify-around items-center">
          <button
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setIsOpen(true)
            }}
            className="relative flex items-center justify-center w-36 h-10 bg-yellow-500 rounded-lg font-medium text-sm transition-transform duration-300 transform hover:scale-105"
          >
            <span className="mr-2">FILTER</span>
            <BsFilter className="w-5 h-5" />
          </button>
          <h2 className="font-semibold text-xl">
            {(totalCount || 0).toLocaleString('en-US')} RESULTS
          </h2>
        </div>
      </div>
      {total_pages ? (
        <div className={'my-auto flex w-full justify-center pb-2'}>
          <Pagination
            page={current_page}
            totalPages={total_pages}
            pageChange={pageChange}
          />
        </div>
      ) : (
        <></>
      )}
      {children}
    </>
  )
}

export default Mobile
